import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListIndented32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconListIndented32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 24V7a1 1 0 0 1 2 0v17a1 1 0 1 1-2 0M28 8a1 1 0 0 1-1 1H10a1 1 0 0 1 0-2h17a1 1 0 0 1 1 1m-1 11a1 1 0 1 0 0-2H10a1 1 0 1 0 0 2zm-2-6a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h14a1 1 0 0 1 1 1m-1 11a1 1 0 1 0 0-2H10a1 1 0 1 0 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListIndented32);
